import Countries from "const/Countries";
import Currencies from "const/Currencies";
import DateFormats from "const/DateFormats";
import DateTimeFormats from "const/DateTimeFormats";
import moment from "moment";

export default class Dates {
  static formatApiDate(date, restrictToMonth = false) {
    const { API_DATE, API_MONTH_DATE } = DateTimeFormats;

    return moment.utc(date).format(restrictToMonth ? API_MONTH_DATE : API_DATE);
  }

  static formatNoTimeZoneDate(date, utc = true) {
    return (utc ? moment.utc(date) : moment(date)).format(DateTimeFormats.NO_TIMEZONE_FORMAT);
  }

  static parseDate(rawValue, countryCode, currency) {
    const { CA, US } = Countries;

    const caLocale = currency === Currencies.CAD || countryCode === CA;

    const usLocale = currency === Currencies.USD || countryCode === US;

    const dateLocale = caLocale ? CA : (usLocale ? US : null);

    const formats = dateLocale === US
      ? [...DateFormats.US_PARSE, ...DateFormats.BASE_PARSE, ...DateFormats.CA_PARSE]
      : (
        dateLocale === CA
          ? [...DateFormats.CA_PARSE, ...DateFormats.BASE_PARSE, ...DateFormats.US_PARSE]
          : [...DateFormats.BASE_PARSE, ...DateFormats.US_PARSE, ...DateFormats.CA_PARSE]
      );

    const parsedDate = rawValue ? moment.utc(rawValue, formats, true) : null;

    if (parsedDate && parsedDate.isValid()) return parsedDate;

    return null;
  }
}
